import React from "react";
import { useReduxStore } from "../../hooks/useReduxStore";
import BasicInfoComponent from "../../Components/BasicInfoComponent";
import ChangePasswordComponent from "../../Components/ChangePasswordComponent";
import { useState } from "react";
import { Button } from "@material-tailwind/react";
import EmailVerificationModal from "../Login/EmailVerificationModal.jsx";

export default function DashboardProfile() {
  const { getState } = useReduxStore();
  const [ch_password, setChPassword] = useState(false);
  const [showEmailVerificationModal, setShowEmailVerificationModal] = useState(false);
  return (
    <>
    <div className="space-y-8 px-4 py-4">
      {/* Header */}
      <div className="bg-blueGray border-2 border-borderGray rounded-md p-6 shadow-sm">
        <h1 className="text-2xl font-semibold text-white mb-2">Profile Settings</h1>
        <p className="text-gray-300">Manage your account information and preferences</p>
      </div>

      {/* Profile Content */}
      <div className="bg-blueGray border-2 border-borderGray rounded-md p-8 shadow-sm">
        {!ch_password ? (
          <BasicInfoComponent setShowEmailVerificationModal={setShowEmailVerificationModal} />
        ) : (
          <ChangePasswordComponent setShowEmailVerificationModal={setShowEmailVerificationModal} />
        )}
        
        <div className="mt-10 pt-6 border-t border-borderGray">
          <button
            onClick={() => setChPassword(!ch_password)}
            className="border border-white text-white px-6 py-2 rounded hover:bg-primaryBlue text-md font-medium transition-colors"
          >
            {ch_password ? "Back to Profile" : "Change Password"}
          </button>
        </div>
      </div>
    </div>
      <EmailVerificationModal open={showEmailVerificationModal}  onClose={()=>setShowEmailVerificationModal(false)} />
    </>
  );
}
